import VirtualTour from './VitualTour';

export default VirtualTour;